<div class="main-container" *ngIf="!isLoading">

  <div class="page-header" data-cy="patient-portal-treatments-header">
    Treatment Plans
  </div>

  <mat-divider></mat-divider>

  <div class="no-invoices-message" *ngIf="treatmentPlans.length === 0" data-cy="patient-portal-treatments-no-plans-message">
    You currently have no treatment plans
  </div>

  <div class="payments-container" *ngIf="treatmentPlans.length > 0">

    <div class="payment-item" *ngFor="let treatmentPlan of treatmentPlans; let i = index;" [class.offset]="i % 2">

      <div class="item-detail" data-cy="patient-portal-treatments-plan-description-label">
        {{ treatmentPlan.Description }}
      </div>

      <!--<div class="item-detail">
        {{ paymentObj.PaymentAmount | currency }}
      </div>-->

      <div class="item-detail"
           [class.paid-detail]="treatmentPlan.approved"
           [class.unpaid-detail]="!treatmentPlan.approved"
           data-cy="patient-portal-treatments-plan-status-label">
        {{ treatmentPlan.approved ? 'Approved' : 'Awaiting Approval' }}
      </div>

      <div class="item-detail">
        <button mat-button color="primary" (click)="openReportForSelectedOption(treatmentPlan)" data-cy="patient-portal-treatments-open-plan-button">Open</button>
      </div>

    </div>

  </div>

</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="patient-portal-treatments-loading-spinner">
  <mat-spinner></mat-spinner>
</div>
